/**
 * 404 — page not found.
 */
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { currentLocale } from '../i18n/index.ts';
import { homePath } from '../i18n/routes.ts';

export function NotFoundPage(): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <main
      style={{
        maxWidth: '28rem',
        margin: '0 auto',
        // +--safe-top: also outside DashboardLayout, so the logo is topmost.
        padding: 'calc(4rem + var(--safe-top)) 1.25rem 4rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1.5rem',
        textAlign: 'center',
      }}
    >
      <img
        src="/brand/logo-international-horizontal.png"
        alt={t('brand.name')}
        style={{ height: '50px', width: 'auto', maxWidth: '100%' }}
      />
      <h1 className="ns-display" style={{ fontSize: '1.75rem', margin: 0 }}>
        {t('notFound.title')}
      </h1>
      <p style={{ fontSize: '0.9375rem', color: 'var(--ns-ink-2)', lineHeight: 1.6, margin: 0 }}>
        {t('notFound.body')}
      </p>
      <Link className="ns-cta" to={homePath(currentLocale())}>
        {t('notFound.back')}
      </Link>
    </main>
  );
}
